module.exports = {"contact_content":{"form":{"url":"https://docs.google.com/forms/d/1Cr8v0RlYwMlj-noWOidOcetI4O77r30fkMNIp-zCgwA","name_name":"entry.1415210662","name_email":"entry.105899179","name_title":"entry.1336314311","name_message":"entry.905916595"}}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/in/setting/contact/setting.json
// module id = 642
// module chunks = 0 1 2 3 4 5